module.exports = __webpack_public_path__ + "img/ogp_temac_big.01488964.jpg";